export enum ActionConstants {
  CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE',
}
